/**
 * Centralized authentication error detection
 * 
 * This module provides a unified way to detect authentication errors
 * across the application, preventing inconsistent error handling that
 * can lead to session issues and infinite retry loops.
 */

export function isAuthError(err: any): boolean {
  if (!err) return false;
  
  const msg = String(err?.message || '').toLowerCase();
  const code = String(err?.code || '');
  const status = err?.status;

  return (
    status === 401 ||
    status === 403 ||
    code === 'PGRST301' ||
    msg.includes('jwt') ||
    msg.includes('auth') ||
    msg.includes('token') ||
    msg.includes('session') ||
    msg.includes('unauthorized') ||
    msg.includes('forbidden')
  );
}

/**
 * Handles authentication errors consistently
 * Returns true if the error was an auth error (so caller can stop retrying)
 */
export function handleAuthError(err: any): boolean {
  if (isAuthError(err)) {
    console.error('Auth error detected:', {
      message: err?.message,
      code: err?.code,
      status: err?.status
    });
    // Don't throw - let the caller decide what to do
    // This prevents infinite retry loops
    return true;
  }
  return false;
}


